import { render, staticRenderFns } from "./Logos.vue?vue&type=template&id=265c1d88&"
import script from "./Logos.vue?vue&type=script&lang=ts&"
export * from "./Logos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports